import styled, { css } from 'styled-components'

export const Container = styled.div`
    display: flex;
    padding: 1rem;
    border-radius: 10px;
`

export const LeftSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.5rem;
`

export const RightSection = styled.div`
    margin-left: 1.5rem;
    width: 100%;

`

export const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    width: 60px;
    height: 60px;
`

export const Title = styled.p`
    margin: 0;
`

export const SubTitle = styled.span`
    display: flex;
`